import { XIcon } from '@music-vine/cadence/icons';
import { AnimatePresence, motion } from 'motion/react';
import { Button } from '@music-vine/cadence/ui';
import { cn } from '@/lib/utils';
import type { Variants } from 'motion/react';
export const MobileBanner = ({
  show,
  isExiting,
  anyPlayerActive,
  popInVariants,
  onDismiss,
  children,
  noXIcon,
  containerClassName
}: {
  show: boolean;
  isExiting: boolean;
  anyPlayerActive?: boolean;
  popInVariants: Variants;
  onDismiss: () => void;
  children?: React.ReactNode;
  noXIcon?: boolean;
  containerClassName?: string;
}) => <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="MobileBanner" data-sentry-source-file="MobileBanner.tsx">
    {!!show && !isExiting && <motion.div animate="visible" className={cn('fixed right-0 left-0 z-40 mx-auto w-[90vw] max-w-[520px]', anyPlayerActive ? 'bottom-[12%]' : 'bottom-[5%]')} data-page-popup drag dragConstraints={{
    top: 0
  }} dragDirectionLock dragSnapToOrigin exit="exit" initial="hidden" onDragEnd={(event, info) => {
    if (info.offset.x < -50 || info.offset.x > 50 || info.offset.y > 50) {
      onDismiss();
    }
  }} variants={popInVariants}>
        <div className={cn('relative overflow-hidden rounded-2xl', 'bg-white dark:bg-gray-950', 'shadow-[0px_0px_15px_1px_rgba(35,37,37,0.08)] dark:shadow-[0px_0px_15px_1px_rgba(35,37,37,0.08)]', 'transition-opacity duration-700', 'border-1 border-gray-150 border-solid dark:border-gray-800', containerClassName)}>
          {children}
          {noXIcon ? null : <Button className={cn('absolute top-1.5 right-1.5 z-10 h-6 w-6 rounded-full bg-white p-1 dark:bg-gray-950')} onClick={onDismiss} size="icon" variant="transparent">
              <span className="sr-only">dismiss popup</span>
              <XIcon className="h-4 w-4 text-gray-950 dark:text-white" />
            </Button>}
        </div>
      </motion.div>}
  </AnimatePresence>;